import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { seoData, notFoundSeo, SITE_URL } from "./seoData";

// Updates a <meta> tag in the page head (or creates it if it is missing).
function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function removeMeta(attr, key) {
  const el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (el) el.remove();
}

function setCanonical(url) {
  let link = document.head.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", url);
}

function removeCanonical() {
  const link = document.head.querySelector('link[rel="canonical"]');
  if (link) link.remove();
}

export default function Seo() {
  const { pathname } = useLocation();

  useEffect(() => {
    // "/toilets/" and "/toilets" are treated as the same page
    const path = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
    const page = seoData[path];
    const { title, description } = page || notFoundSeo;

    document.title = title;
    setMeta("name", "description", description);
    setMeta("name", "robots", page ? "index, follow" : "noindex, follow");
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);

    if (page) {
      const url = SITE_URL + path; // "/" becomes https://www.airloo.in/
      setCanonical(url);
      setMeta("property", "og:url", url);
    } else {
      removeCanonical();
      removeMeta("property", "og:url");
    }
  }, [pathname]);

  return null;
}
